export const AMPLITUDE_SESSION_TIMEOUT = 30 * 60 * 1000;
export const AMPLITUDE_START_SESSION_EVENT_TYPE = '[Amplitude] Start Session';
